<div class="detail">
  <gmt-button [clickAction]="goToDetail" class="mb-10"><i class="fa fa-chevron-left mr-5"></i> Zpět</gmt-button>
  <div [loading]="!occupationObject">
    <ng-container *ngIf="occupationObject">
      <h1>Editace záboru
        <span>{{ occupationTypeName }} / {{ occupationObject.parcel|parcelnumber }}</span>
      </h1>
      <div class="mt-20">
        <gmt-navbar *ngIf="showModeSelector()" [tabs]="getApplicableEditModeOptions()" [isActiveTab]="isActiveTab" (changed)="onEditModeChange($event)">
          <ng-container *ngTemplateOutlet="modeContent"></ng-container>
        </gmt-navbar>
        <ng-container *ngIf="!showModeSelector()">
          <ng-container *ngTemplateOutlet="modeContent"></ng-container>
        </ng-container>
      </div>
      <ng-template #modeContent>
        <div class="fieldset" *ngIf="(!showModeSelector() || editMode === 'solution-type') && isSolutionType()">
          <div class="legend">Způsob řešení záboru</div>
          <gmt-switch [options]="occupationSolutionOptions" [(selectedId)]="occupationObject.solutionType">
          </gmt-switch>
          <div class="mt-20">
            <gmt-button [clickAction]="update" [gmtDisabled]="!isValid()">Uložit</gmt-button>
          </div>
        </div>

        <div class="fieldset-group" *ngIf="(!showModeSelector() || editMode === 'price') && (occupationObject.solutionType || occupationLongerThanOneYear() || occupationShorterThanOneYear())">
          <div class="fieldset">
            <div class="legend">Způsob určení ceny</div>
            <gmt-switch [options]="priceType" [selectedId]="occupationObject.rentalPriceType"
                        (selectedIdChange)="onRentalPriceTypeChange($event)"></gmt-switch>
          </div>
          <div class="fieldset">
            <div class="legend">Cena</div>
            <div class="clearfix">
              <div class="column-100">
                <label class="required">Délka nájmu [<span class="unit">měsíce</span>]</label>
                <div class="input"><input type="text" [(ngModel)]="occupationObject.rentalLength" gmtInputNumber/></div>
              </div>

              <div class="column-100">
                <ng-container *ngIf="occupationObject.rentalPriceType === 'F'">
                  <label class="required">Rok cenového výměru MF</label>
                  <div class="info" *ngIf="occupationObject.priceAssessmentPrice">
                    {{ occupationObject.priceAssessmentYear }}
                  </div>
                  <div class="input" *ngIf="!occupationObject.priceAssessmentPrice">
                    <input type="text" [(ngModel)]="occupationObject.priceAssessmentYear" gmtInputNumber/>
                  </div>
                </ng-container>

                <ng-container *ngIf="occupationObject.rentalPriceType === 'E'">
                  <label class="required">Číslo znaleckého posudku</label>
                  <div class="input"><input type="text" [(ngModel)]="occupationObject.rentalExpertOpinionNumber"/></div>

                  <label class="required">Datum znaleckého posudku</label>
                  <div class="input"><input type="text" pick-a-date
                                            [(ngModel)]="occupationObject.rentalExpertOpinionDate"/></div>
                </ng-container>

                <ng-container *ngIf="occupationObject.rentalPriceType === 'O'">
                  <label class="required">Původ ceny</label>
                  <div class="input"><input type="text" [(ngModel)]="occupationObject.rentalOtherPriceSource"/></div>
                  <div class="column-100">
                    <label class="required">Způsob výpočtu ceny</label>
                    <gmt-switch [options]="priceUnit" [(selectedId)]="occupationObject.rentalPriceUnit"></gmt-switch>
                  </div>
                </ng-container>

                <ng-container
                  *ngIf="occupationObject.rentalPriceType === 'O' && occupationObject.rentalPriceUnit === 'T'">
                  <label class="required">Cena za pozemek [<span class="unit">Kč</span>]</label>
                  <div class="input"><input type="text" [(ngModel)]="occupationObject.totalRentPrice" gmtInputNumber/>
                  </div>
                </ng-container>

                <ng-container
                  *ngIf="occupationObject.rentalPriceType !== 'O' || occupationObject.rentalPriceUnit !== 'T'">
                  <label class="required">Cena za pozemek [<span class="unit">Kč/m<sup>2</sup>/rok</span>]</label>
                  <div class="info"
                       *ngIf="occupationObject.rentalPriceType == 'F' && occupationObject.priceAssessmentPrice">{{ occupationObject.priceAssessmentLandPrice }}
                  </div>
                  <div class="input"
                       *ngIf="occupationObject.rentalPriceType != 'F' || !occupationObject.priceAssessmentPrice"><input
                    type="text" [(ngModel)]="occupationObject.priceAssessmentLandPrice" gmtInputNumber/></div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="expert-indent" *ngIf="occupationObject.rentalPriceType === 'E'">
            <expert-select-form [expert]="occupationObject.rentalExpert"
                                (changed)="onChangeExpert($event)"></expert-select-form>
          </div>
          <div class="mb-20" style="padding: 0 20px 20px">
            <gmt-button [clickAction]="update" [gmtDisabled]="!isValid()">Uložit</gmt-button>
          </div>
        </div>

        <div class="fieldset"
             *ngIf="(!showModeSelector() || editMode === 'priority') && (priorityOptions.length > 0 && occupationObject.occupationType.category === 'permanent')">
          <div class="legend">Priorita záboru</div>
          <div class="clearfix">
            <div class="column-100">
              <label>Kategorie priority</label>
              <div class="input">
                <gmt-select
                  [optionItems]="priorityOptions"
                  [data]="priorityHolder"
                  field="priorityIndex"
                  required="true"
                ></gmt-select>
              </div>
            </div>
          </div>
          <div class="mt-20">
            <gmt-button [clickAction]="update" [gmtDisabled]="!isValid()">Uložit</gmt-button>
          </div>
        </div>

        <div class="fieldset"
             *ngIf="(!showModeSelector() || editMode === 'final-solution-type') &&
              occupationSolutionTypeOptions.length > 0 && occupationObject.occupationType &&
              ((isAdditionalTypeProject && occupationObject.occupationType.category === 'permanent' && occupationObject.countCasesNotOwnersStatementLiability == 0) || (isInvestTypeProject && occupationObject.countCases == 0))"
        >
          <div  class="legend">Volba změny vypořádání záboru</div>
          <div class="checklist">
            <ng-container *ngFor="let option of occupationSolutionTypeOptions">
              <div class="checklist-item" (click)="onOccupationSolutionTypeOptionSelected(option)">
                <gmt-radio [gmtChecked]="option.id === occupationObject.finalSolutionType.id"></gmt-radio>
                <span>{{ option.name }}</span>
              </div>

              <div class="other-changes-container"
                   *ngIf="option.key === FinalSolutionTypesEnum.OTHER_CHANGE && occupationObject.finalSolutionType?.key === FinalSolutionTypesEnum.OTHER_CHANGE && occupationObject.finalSolutionOtherChange">
                <div class="checklist-item unborder"
                     (click)="occupationObject.finalSolutionOtherChange.changeOccupationType = !occupationObject.finalSolutionOtherChange.changeOccupationType">
                  <gmt-checkbox
                    [gmtChecked]="occupationObject.finalSolutionOtherChange?.changeOccupationType"></gmt-checkbox>
                  <span>Změna typu záboru</span>
                  <span class="other-change-current-value">{{ occupationObject.zabtyptx }}</span>
                </div>
                <div class="other-change-input-row" *ngIf="occupationObject.finalSolutionOtherChange.changeOccupationType">
                  <label class="required">Nový typ záboru</label>
                  <gmt-select
                    [optionItems]="occupationTypeList"
                    [data]="occupationObject.finalSolutionOtherChange"
                    field="newOccupationType"
                    required="true"
                  ></gmt-select>
                </div>

                <ng-container
                  *ngIf="occupationObject.finalSolutionOtherChange?.changeOccupationType && permanentWithPurchase.includes(occupationObject.finalSolutionOtherChange?.newOccupationType?.number) && acquirerList.length > 0">
                  <div class="acquirer-grid">
                    <div class="other-change-input-row">
                      <label class="required">Nový nabyvatel</label>
                      <gmt-select
                        [optionItems]="acquirerList"
                        [data]="occupationObject.finalSolutionOtherChange"
                        field="newNabyvatel"
                        required="true"
                      ></gmt-select>
                    </div>
                    <div *ngIf="occupationObject.nabyvatel" class="other-change-input-row">
                      <label>Původní nabyvatel</label>
                      <div class="input"><input type="text" [ngModel]="occupationObject.nabyvatel" disabled/></div>
                    </div>
                  </div>
                </ng-container>

                <div class="checklist-item unborder"
                     (click)="occupationObject.finalSolutionOtherChange.changeConstructionObjects = !occupationObject.finalSolutionOtherChange.changeConstructionObjects">
                  <gmt-checkbox
                    [gmtChecked]="occupationObject.finalSolutionOtherChange?.changeConstructionObjects"></gmt-checkbox>
                  <span>Změna objektové skladby záboru</span>
                  <span class="other-change-current-value">
                    <div *ngFor="let co of occupationObject.constructionObjects">{{ co | constructionObjectName }}</div>
                  </span>
                </div>
                <div class="other-change-input-row" *ngIf="occupationObject.finalSolutionOtherChange?.changeConstructionObjects">
                  <label class="required">Objektová skladba</label>
                  <gmt-select
                    resource="construction-objects"
                    [data]="occupationObject.finalSolutionOtherChange"
                    field="newConstructionObjects"
                    [multiselect]="true"
                    [itemPipe]="constructionObjectNamePipe"
                    [filter]="{ filters: { validity: 'valid' } }"
                    selectTitle="Stavební objekt"
                    required="true"
                  ></gmt-select>
                </div>

                <div class="checklist-item unborder"
                     (click)="occupationObject.finalSolutionOtherChange.changeOccupationNumber = !occupationObject.finalSolutionOtherChange.changeOccupationNumber">
                  <gmt-checkbox
                    [gmtChecked]="occupationObject.finalSolutionOtherChange?.changeOccupationNumber"></gmt-checkbox>
                  <span>Změna čísla záboru</span>
                  <span class="other-change-current-value">{{ occupationObject.zabcis }}</span>
                </div>
                <div class="other-change-input-row" *ngIf="occupationObject.finalSolutionOtherChange.changeOccupationNumber">
                  <label class="required">Číslo záboru</label>
                  <input class="input" type="text" [(ngModel)]="occupationObject.finalSolutionOtherChange.newOccupationNumber"/>
                </div>

              </div>

              <div class="reason-container"
                   *ngIf="occupationObject.finalSolutionType?.id === option.id">
                <label class="reason-label" [class.required]="option.key === FinalSolutionTypesEnum.CANCELLED || option.key === FinalSolutionTypesEnum.CANCELLED_INVEST">
                  {{ 'Důvod požadavku' }}
                </label>
                <textarea [(ngModel)]="occupationObject.finalSolutionReason" class="reason"></textarea>
              </div>
            </ng-container>
          </div>
          <div class="mt-20">
            <gmt-button [clickAction]="update" [gmtDisabled]="!isValid()">Uložit</gmt-button>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </div>
</div>
